import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
    static targets = ['modal', 'form', 'checkbox', 'optionAction']

    submit(e) {
        const formElement = this.formTarget;
        formElement.submit();
    }

    action() {
        if(this.optionActionTarget.value == "destroy") {
            this.openModal()
        }
    }

    destroy(e) {
        let clinicIds = []
        this.checkboxTargets.forEach(checkbox => {
            if (checkbox.checked) {
                clinicIds.push(checkbox.value)
            }
        })

        if (clinicIds.length > 0) {
            Rails.ajax({
                url: `clinics/multi_destroy?clinic_ids=${clinicIds}`,
                type: "DELETE",
                success: (response) => {
                    if (response.success) {
                        location.reload()
                    }
                }
            })
        }
    }

    openModal() {
        this.modalTarget.setAttribute("style", "display: block;")
    }

    closeModal() {
        this.modalTarget.setAttribute("style", "display: none;")
    }
}
